{
	"language": {
		"select": "Selecionar idioma",
		"sectionTitle": "Idioma",
		"changeSuccess": "Idioma alterado com sucesso"
	},
	"assistant": {
		"composer": {
			"placeholder": "Pergunte ao {{assistantName}}",
			"disclaimer": "{{assistantName}} pode cometer erros. Verifique informações importantes."
		},
		"greeting": {
			"initialMessage": "👋 Olá! Sou o assistente de aprendizado **{{assistantName}}** e estou aqui para ajudar você a se preparar melhor para o **{{context}}!** Vamos analisar especificamente o item que você respondeu sobre **{{topic}}.**",
			"starter": "Olá, sou **{{assistantName}}**. Como posso ajudar?"
		},
		"chips": {
			"askYourOwn": "Faça sua própria pergunta",
			"askFollowUp": "Faça uma pergunta de acompanhamento"
		},
		"emptyState": {
			"title": "{{assistantName}} é seu assistente de aprendizado com IA",
			"contextSubtitle": "Pergunte qualquer coisa sobre {{context}}",
			"activateSubtitle": "{{assistantName}} será ativado depois que você responder à pergunta"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Estudo rápido",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Defina uma data da prova para receber recomendações melhores.",
					"examDateWithValue": "Data da prova: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Poderia ser melhor",
				"itsAwesome": "É incrível"
			},
			"title": "Você está indo muito bem!",
			"body": "Estamos muito felizes em ver sua dedicação aos estudos! Como tem sido sua experiência com o app até agora? Você se importaria de compartilhar sua opinião em uma avaliação?",
			"cta": "Talvez mais tarde"
		},
		"actions": {
			"studyWeak": "Focar em áreas fracas",
			"viewProgress": "Ver seu progresso",
			"seeRank": "Ver sua posição",
			"seeRankings": "Ver classificação",
			"unlock": "Desbloquear conteúdo Premium",
			"unlockTooltip": "Tenha acesso a recursos exclusivos e materiais de estudo avançados ao desbloquear o conteúdo Premium",
			"startCustomSession": "Criar uma sessão personalizada",
			"startCustomSessionTooltip": "Inicie uma sessão de estudo personalizada para focar em áreas específicas do seu estudo",
			"takeDiagnostic": "Fazer diagnóstico",
			"takeDiagnosticTooltip": "Faça um diagnóstico para avaliar seu nível atual e adaptar seu plano de estudo",
			"viewDiagnostic": "Ver resultados do diagnóstico",
			"viewDiagnosticTooltip": "Veja os resultados do seu diagnóstico para conhecer seus pontos fortes e áreas para melhorar",
			"viewPodcasts": "Ouvir podcasts",
			"viewPodcastsTooltip": "Acesse podcasts educacionais para aprimorar sua experiência de aprendizado",
			"upgradeToPremium": "Ir para o Premium",
			"upgradeToPremiumTooltip": "Faça upgrade para o Premium e acesse todo o conteúdo e recursos",
			"extendAccess": "Estender acesso",
			"extendAccessTooltip": "Estenda seu acesso ao conteúdo e aos recursos Premium",
			"setExamDate": "Definir data da prova",
			"setExamDateTooltip": "Defina a data da sua prova para acompanhar seu progresso e se preparar"
		},
		"exam": {
			"daysAgo_one": "há {{count}} dia",
			"daysAgo_other": "há {{count}} dias",
			"untilExam_one": "{{count}} dia até a prova",
			"untilExam_other": "{{count}} dias até a prova",
			"isToday": "A prova é hoje!"
		},
		"stats": {
			"mastery": "Domínio",
			"completed_one": "Item respondido",
			"completed_other": "Itens respondidos",
			"completedValue": "{{count}}",
			"xpEarned": "XP obtido",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Precisão",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "Sua proficiência estimada em {{skill, lowercase}} é {{level, lowercase}}",
			"itemsAnsweredTooltip": "Número total de itens que você respondeu até agora",
			"responsesAnsweredTooltip": "Número total de respostas que você enviou até agora",
			"examDateTooltip": "Sua prova é em {{date}}",
			"skillCta": {
				"diagnostic": "Diagnóstico",
				"practice": "Praticar"
			}
		},
		"menu": {
			"settings": "Configurações",
			"profile": "Perfil"
		},
		"diagnostics": {
			"title": "Diagnósticos",
			"free": "Grátis",
			"duration": "{{count}} {{item}} • {{minutes}} min",
			"completed": "Total concluído: {{count}} {{item}}",
			"start": "Iniciar",
			"viewReport": "Ver relatório",
			"resume": "Retomar"
		},
		"practiceTests": {
			"title": "Simulados",
			"sectionalTestsTitle": "Simulados seccionais",
			"diagnosticAssessmentsTitle": "Avaliações diagnósticas",
			"premiumChipTooltip": "Simulados Premium completos para a prova {{examName}}",
			"freeChipTooltip": "{{label}} para a prova {{examName}}",
			"freeChipTooltipDefault": "Avaliações diagnósticas gratuitas para a prova {{examName}}",
			"completedDescription_one": "{{count}} item • {{date}}",
			"completedDescription_other": "{{count}} itens • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} item • {{timeRemaining}} restantes",
			"activeDescription_other": "{{attempted}}/{{count}} itens • {{timeRemaining}} restantes",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} item • {{timeRemaining}} restantes • Iniciado em: {{startedOn}} • Termina em: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} itens • {{timeRemaining}} restantes • Iniciado em: {{startedOn}} • Termina em: {{endsOn}}",
			"notStartedDescription_one": "{{count}} item • {{duration}}",
			"notStartedDescription_other": "{{count}} itens • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} item • {{duration}} • Termina em: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} itens • {{duration}} • Termina em: {{endsOn}}",
			"viewResultsCta": "Ver resultados",
			"startCta": "Iniciar",
			"chips": {
				"items_one": "{{count}} item",
				"items_other": "{{count}} itens",
				"progress_one": "{{attempted}}/{{count}} item",
				"progress_other": "{{attempted}}/{{count}} itens",
				"timeRemaining": "{{time}} restantes",
				"startedOn": "Iniciado em: {{date}}",
				"endsOn": "Termina em: {{date}}",
				"timeLeft": "{{time}} restantes"
			},
			"status": {
				"notStarted": {
					"label": "Não iniciado",
					"section": "Simulados completos"
				},
				"inProgress": {
					"label": "Em andamento",
					"section": "Em andamento"
				},
				"completed": {
					"label": "Concluído",
					"section": "Concluído"
				},
				"legacyReports": {
					"label": "Relatórios legados",
					"section": "Relatórios legados"
				},
				"migratedReports": {
					"label": "Relatórios migrados",
					"section": "Relatórios migrados"
				}
			}
		},
		"skills": {
			"title": "Habilidades",
			"unlockSubtitle": "Desbloqueie o premium para praticar",
			"startCta": "Praticar",
			"freeItemsIncludedChip": "Itens grátis incluídos",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}} de {{count, number}} item grátis respondido",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}} de {{count, number}} itens grátis respondidos",
			"progressCards": {
				"questionTypesTitle": "Desempenho por tipo de questão",
				"questionTypesSubtitle": "Seu desempenho nos tipos de questão de {{skill}}",
				"proficiencyTitle": "Desempenho por proficiência",
				"proficiencySubtitle": "Seu progresso nos níveis de {{skill}}",
				"questionTypeCardSubtitle": "Progresso por nível de proficiência",
				"bySkillTitle": "Desempenho por habilidade",
				"bySkillSubtitle": "Progresso geral nas habilidades",
				"needsImprovementTitle": "Precisa melhorar",
				"needsImprovementSubtitle": "Habilidades nas quais focar a seguir",
				"skillPerformanceTitle": "Desempenho em {{skill}}",
				"skillPerformanceSubtitle": "Progresso por tipo de questão e proficiência",
				"skillLevelSubtitle": "Seu progresso neste nível de habilidade",
				"skillsPerformanceTitle": "Desempenho das habilidades",
				"performanceByItemDifficulty": "Desempenho por proficiência do item",
				"performanceByItemDifficultyCaption_one": "Mostra sua precisão por nível de proficiência, com base em {{count}} item tentado",
				"performanceByItemDifficultyCaption_other": "Mostra sua precisão por nível de proficiência, com base em {{count}} itens tentados",
				"questionTypePartSubtitle": "{{skill}} · Parte {{part}}",
				"activityGoalTitle": "Atividade e progresso da meta",
				"recentActivityTitle": "Atividade recente",
				"goalProgressTitle": "Progresso da meta",
				"goalProgressSubtitle": "Pontuação geral · Últimas 7 semanas",
				"goalProgressInsight": "Você está melhorando constantemente. Está 14 pontos abaixo da sua meta e pode alcançá-la em cerca de 3 semanas.",
				"goalProgressActualLabel": "Sua pontuação",
				"goalProgressTargetLabel": "Meta",
				"goalProgressTimeAxisLabel": "Tempo",
				"goalProgressScoreAxisLabel": "Progresso geral",
				"statusTitle": "Seu status",
				"diagnosticsTitle": "Diagnósticos",
				"diagnosticsReviewCta": "Revisar",
				"strengthsFocusTitle": "Pontos fortes e áreas de foco",
				"strengthsFocusSubtitle": "Suas áreas mais fortes e os tipos de questão que precisam de mais prática",
				"strengthsLabel": "Pontos fortes",
				"focusAreasLabel": "Áreas de foco",
				"recommendedNextStepLabel": "Próxima etapa recomendada",
				"recommendedNextStepCta": "Iniciar",
				"practiceTestsViewMore": "Ver todos os {{count}} simulados"
			},
			"proficiencySection": "Praticar por nível de proficiência"
		},
		"recommendedTasks": {
			"sectionTitle": "Recomendado para você",
			"startSessionAction": "Praticar",
			"resumeAction": "Retomar",
			"reviewResultsAction": "Revisar resultados",
			"startTestAction": "Iniciar prova",
			"activeTestBody": "Conclua sua avaliação em andamento",
			"completedTestBody": "Revise seu desempenho e suas respostas",
			"diagnosticBody": "Faça {{label}} para se familiarizar com o formato da prova",
			"diagnosticDefaultLabel": "diagnóstico gratuito",
			"practiceTestBody": "Avalie sua preparação para a prova com um teste cronometrado.",
			"sectionalTestBody": "Faça um teste focado para praticar suas habilidades de {{skills}}.",
			"weakSkillTitle": "Fortaleça seu {{skill}}",
			"weakSkillBody": "Prática de {{questionType}}, com foco no que você ainda não dominou.",
			"strongSkillTitle": "Mantenha seu {{skill}} afiado",
			"strongSkillBody": "Você está bem aqui. Um set rápido de {{questionType}} mantém assim.",
			"mixedSkillTitle": "Complete seu {{skill}}",
			"mixedSkillBody": "Um set misto de {{questionTypes}}, com foco no que você errou.",
			"higherDifficultySkillTitle": "Suba para {{proficiency}}",
			"higherDifficultySkillBody": "Você já domina {{questionType}} neste nível. Estes vão um pouco além.",
			"itemsChip_one": "{{count}} item",
			"itemsChip_other": "{{count}} itens",
			"timeRemainingChip": "{{minutes}} min restantes",
			"timeRemainingChipCompact": "{{minutes}} min"
		},
		"itemTypes": {
			"answeredLabel_one": "Item respondido",
			"answeredLabel_other": "Itens respondidos",
			"answeredAll": "Todos",
			"answeredPartial": "{{answered}} de {{total}}",
			"cardSubtitleResponses_one": "{{count}} resposta",
			"cardSubtitleResponses_other": "{{count}} respostas",
			"responsesLabel_one": "Resposta",
			"responsesLabel_other": "Respostas",
			"cardSubtitleComplete": "Todos os itens respondidos",
			"cardSubtitlePartial": "{{attempted}} de {{total}} itens respondidos",
			"detail": {
				"skillLabel": "Habilidade",
				"estimatedLevelLabel": "Nível estimado"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} resposta",
			"responseCount_other": "{{count, number}} respostas"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "{{count, number}} item de prática grátis incluído",
			"freeContentBannerTitle_other": "{{count, number}} itens de prática grátis incluídos",
			"freeContentBannerBody": "Pratique os itens de {{skills}} quando quiser. Melhore seu plano para desbloquear o Study-Pack completo.",
			"freeContentBannerCta": "Iniciar prática grátis"
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "Veja como você se compara aos outros"
		},
		"home": {
			"title": "Início"
		},
		"podcasts": {
			"description": "Ouça podcasts de ortopedia apresentados por especialistas."
		},
		"more": {
			"title": "Mais configurações"
		}
	},
	"emptyState": {
		"progress": {
			"title": "Sem progresso de estudo",
			"subtitle": "À medida que você estudar, seu progresso aparecerá aqui",
			"cta": "Estudar agora"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Erro",
			"body": "Não foi possível criar a sessão. Tente novamente"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Avançado",
			"highIntermediate": "Intermediário",
			"intermediate": "Intermediário",
			"basic": "Básico",
			"none": "Não respondido",
			"high": "Dominado",
			"medium": "Quase lá",
			"low": "Precisa melhorar"
		}
	},
	"leaderboard": {
		"you": "Você está aqui",
		"periods": {
			"all_time": "Todo o período",
			"month": "Este mês",
			"week": "Esta semana"
		},
		"scope": {
			"global": "Global",
			"friends": "Amigos"
		},
		"friends": {
			"soon": "EM BREVE",
			"comingSoonTitle": "Classificação de amigos",
			"comingSoonBadge": "Em breve",
			"comingSoonDescription": "Acompanhe seu progresso em relação aos amigos e veja quem está no topo da turma."
		},
		"error": {
			"title": "Erro de conexão",
			"description": "Não foi possível carregar a classificação. Verifique sua conexão e tente novamente.",
			"tryAgain": "Tentar novamente"
		},
		"empty": {
			"title": "Ainda não há classificações",
			"description": "Seja o primeiro a começar a aprender e conquistar o primeiro lugar na classificação.",
			"startLearning": "Começar a aprender"
		},
		"topPerformers": "Participantes com melhor desempenho",
		"yourPosition": "Sua posição",
		"rankings": "Classificação",
		"rankingsRange": "Classificação • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "Ganhe XP para entrar na classificação!",
			"description": "Inicie uma sessão de estudo para ganhar seus primeiros pontos e entrar na classificação.",
			"cta": "Inicie sua primeira sessão"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "VOCÊ",
		"podium": {
			"first": "1º",
			"second": "2º",
			"third": "3º"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>para ultrapassar #{{rank}}</rest>",
			"gapHintFromPodium": "<num>+{{value}}</num><unit> XP</unit> <rest>para chegar ao pódio</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Lições",
			"searchPlaceholder": "Pesquisar lições",
			"count_one": "{{count}} lição",
			"count_other": "{{count}} lições",
			"sortModalTitle": "Ordenar lições",
			"filterModalTitle": "Filtrar por tópicos",
			"sort": {
				"popularity": "Popularidade",
				"popularityShort": "Popular",
				"topic": "Tópico",
				"difficulty": "Dificuldade",
				"recent": "Atualizadas recentemente",
				"recentShort": "Atualizado",
				"completed": "Concluído"
			},
			"chips": {
				"all": "Todas",
				"recent": "Atualizadas recentemente",
				"completed": "Concluídas",
				"premium": "Premium",
				"topics": "Tópicos",
				"topicsCount_one": "{{count}} tópico",
				"topicsCount_other": "{{count}} tópicos"
			},
			"chipTooltips": {
				"all": "Mostrar todas as lições.",
				"recent": "Mostrar as lições atualizadas recentemente.",
				"completed": "Mostrar as lições concluídas.",
				"premium": "Mostrar as lições premium.",
				"topics": "Filtrar lições por tópico."
			},
			"filterNames": {
				"premium": "premium",
				"completed": "concluídas",
				"topics": "tópico"
			},
			"empty": {
				"searchTitle_one": "{{count}} lição oculta pela pesquisa",
				"searchTitle_other": "{{count}} lições ocultas pela pesquisa",
				"searchSubtitle": "Tente outras palavras-chave ou limpe sua pesquisa",
				"searchCta": "Limpar pesquisa",
				"filtersTitle_one": "{{count}} lição oculta pelos filtros",
				"filtersTitle_other": "{{count}} lições ocultas pelos filtros",
				"filtersSubtitle_one": "Remova o filtro de {{filters}} para ver mais",
				"filtersSubtitle_other": "Remova os filtros de {{filters}} para ver mais",
				"filtersCta": "Limpar todos os filtros",
				"noneTitle": "Nenhuma lição encontrada",
				"noneSubtitle": "Tente remover os filtros ou iniciar uma nova pesquisa",
				"noneCta": "Redefinir tudo"
			}
		},
		"home": {
			"settings": {
				"a11yLabel": "Abrir configurações"
			},
			"continueLearning": {
				"title": "Continuar aprendendo"
			},
			"suggested": {
				"title": "Sugeridas para você"
			},
			"completed": {
				"title": "Concluídas"
			},
			"all": {
				"title": "Todas as lições"
			},
			"emptyState": {
				"title": "Nenhuma lição ainda",
				"subtitle": "Volte em breve para ver novas lições."
			},
			"card": {
				"resumeCta": "Retomar",
				"progress": "{{value}}% concluído",
				"timeLeft_one": "{{count}} min restante",
				"timeLeft_other": "{{count}} min restantes",
				"duration_one": "{{count}} min",
				"duration_other": "{{count}} min"
			}
		},
		"overview": {
			"header": {
				"title": "Visão geral"
			},
			"startCta": "Começar a aprender",
			"objectives": {
				"title": "Objetivos de aprendizagem"
			}
		},
		"detail": {
			"takeQuizCta": "Fazer o quiz",
			"progress": {
				"label": "Progresso do módulo"
			},
			"activities": {
				"title": "Atividades",
				"completedCount": "{{completed}} de {{total}} concluídas"
			},
			"artifact": {
				"completed": "Concluído",
				"locked": "Bloqueado"
			}
		},
		"stats": {
			"insights": {
				"title": "Insights de progresso"
			},
			"overallProgress": {
				"title": "Progresso geral",
				"completedCount_one": "{{completed}} de {{count}} item concluído",
				"completedCount_other": "{{completed}} de {{count}} itens concluídos"
			},
			"milestones": {
				"title": "Marcos do módulo"
			}
		},
		"studyGuide": {
			"sectionBadge": {
				"label": "Seção {{number}} de {{total}}"
			},
			"upNext": {
				"title": "A seguir"
			}
		}
	},
	"sessionConfig": {
		"title": "Sessão de estudo personalizada",
		"diagnostic": "Diagnóstico",
		"skill": "Habilidades",
		"Proficiency": "Proficiência",
		"Question Type": "Tipos de questão",
		"mastery": "Domínio",
		"sessionLength": "Duração da sessão",
		"itemsChip_one": "{{count}} item",
		"itemsChip_other": "{{count}} itens",
		"durationEstimate": "{{minutes}} min",
		"durationRange": "{{min}}–{{max}} min",
		"noItemsTooltip": "Nenhum item corresponde aos filtros atuais",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Ok",
		"status": {
			"notAnswered": "Não respondido",
			"needsWork": "Precisa melhorar"
		},
		"itemCount": "Você responderá {{count}} itens em {{topics}}",
		"start": "Iniciar sessão",
		"configuringSession": "Configurando sessão",
		"fetchingContent": "Buscando conteúdo",
		"preparingMaterials": "Preparando materiais",
		"almostThere": "Quase lá",
		"startingSession": "Iniciando sessão",
		"playIcon": "play-outline",
		"infoText": "Você responderá **{{numItems}}** {{itemCount}}. Isso levará cerca de **{{timeString}}**.",
		"customSummary": {
			"message": "Estude $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) de {{topics}}.",
			"messageWithMastery": "Estude $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) de {{topics}}, com foco $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) {{masteryLevels}}.",
			"messageAllMasteryLevels": "Estude $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) de {{topics}} em todos os níveis de domínio.",
			"itemCount_one": "{{count}} item",
			"itemCount_other": "{{count}} itens",
			"masteryLevelCount_one": "no nível de domínio",
			"masteryLevelCount_other": "nos níveis de domínio",
			"allTopics": "todos os {{count}} tópicos",
			"more": "{{count}} a mais",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "Estudo rápido",
			"recommended": "Recomendado",
			"custom": "Personalizado",
			"selectHelper": "Toque em uma sessão para selecioná-la e inicie quando estiver pronto.",
			"emptyRecommended": "Nenhuma sessão recomendada está disponível no momento.",
			"summary": "Estude {{count}} itens de {{skill}}. Estimativa de {{minutes}} minutos.",
			"summary_questionType": "Estude {{count}} itens de {{skill}}, {{questionType}}. Estimativa de {{minutes}} minutos.",
			"duration": "{{minutes}} min",
			"durationSelector": {
				"title": "Duração"
			},
			"levelSessions": {
				"rapidRecall": "Recordação rápida",
				"purposefulPractice": "Prática intencional",
				"focusFlow": "Fluxo de foco",
				"itemsLabel": "Itens de {{level}}",
				"itemsLabelGeneric": "itens",
				"summaries": {
					"rapidRecall": "Tenha contato rápido com {{count}} itens de {{level}} que você ainda não respondeu para ampliar gradualmente sua cobertura. Estimativa de {{minutes}} minutos.",
					"purposefulPractice": "Pratique um conjunto equilibrado de {{count}} itens de {{level}}, começando pelo material que mais precisa de atenção. Estimativa de {{minutes}} minutos.",
					"focusFlow": "Fortaleça seus pontos fracos com {{count}} itens de {{level}} que você respondeu com domínio baixo ou médio. Estimativa de {{minutes}} minutos."
				},
				"summariesGeneric": {
					"rapidRecall": "Tenha contato rápido com {{count}} itens que você ainda não respondeu para ampliar gradualmente sua cobertura. Estimativa de {{minutes}} minutos.",
					"purposefulPractice": "Pratique um conjunto equilibrado de {{count}} itens, começando pelo material que mais precisa de atenção. Estimativa de {{minutes}} minutos.",
					"focusFlow": "Fortaleça seus pontos fracos com {{count}} itens que você respondeu com domínio baixo ou médio. Estimativa de {{minutes}} minutos."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "Para personalizar sua experiência, comece com um teste diagnóstico. Os resultados do seu diagnóstico serão usados para criar seu plano de estudos."
	},
	"premium": {
		"chip": "Premium",
		"upgrade": "Faça upgrade para o Premium",
		"unlockTitle": "Desbloqueie a experiência completa de {{productName}}",
		"unlockDescription": "Desbloqueie práticas personalizadas criadas com base no seu tempo de estudo restante.",
		"readyTitle": "Esteja pronto para sua prova de {{date}}",
		"tip": "Seu foco personalizado: o Premium identifica o que praticar em seguida e ajusta seu plano de estudos conforme você evolui."
	},
	"purchase": {
		"success": {
			"headerTitle": "Obrigado pela sua compra!",
			"accessGranted": "O acesso ao seu {{name}} foi concedido com sucesso",
			"studyPack": "Study-Pack",
			"practiceTest": "Simulado",
			"combo": "Combo",
			"documentTitle": "Compra",
			"summary_one": "Parabéns! O **produto** abaixo foi desbloqueado na sua conta. Depois de pressionar {{action}}, o contexto do app será alterado para refletir a prova: **{{examName}}**. Você poderá alterar isso a qualquer momento nas configurações da conta se quiser estudar para outra prova ou comprar outra assinatura.",
			"summary_other": "Parabéns! Os **{{count}} produtos** abaixo foram desbloqueados na sua conta. Depois de pressionar {{action}}, o contexto do app será alterado para refletir a prova: **{{examName}}**. Você poderá alterar isso a qualquer momento nas configurações da conta se quiser estudar para outra prova ou comprar outra assinatura.",
			"unlockedDuration": "Parabéns! Você desbloqueou **{{duration}}** de acesso a **{{name}}**. O acesso expira em **{{expiry}}**.",
			"storeNote": "Observação: os Study-Packs só podem ser acessados pelos nossos apps para celular. Baixe o app compatível com seu dispositivo.",
			"actions": {
				"goToHome": "Ir para a página inicial",
				"startDiagnostic": "Iniciar {{label}}",
				"takeDiagnostic": "Fazer {{label}}",
				"takeFreeDiagnostic": "Fazer diagnóstico gratuito",
				"diagnosticLabel": "diagnóstico"
			}
		},
		"checkout": {
			"headerTitle": "Conclua sua compra"
		},
		"paywall": {
			"studyPackDialogTitle": "Melhore seu plano de estudo",
			"defaultDialogTitle": "Melhore seu plano de estudo",
			"practiceTestDialogTitle": "Desbloqueie simulados",
			"restorePurchaseDialogTitle": "Já comprou?",
			"restorePurchaseDialogSubheadingWeb": "Se não, tente isto:",
			"restorePurchaseDialogBody": "Se você já comprou este produto e ele continua bloqueado, tente o seguinte:\n\n1. Verifique se você entrou na conta correta\n2. Verifique se o produto correto está selecionado\n3. Verifique se sua assinatura não expirou\n4. Verifique se você ativou sua assinatura (confira sua caixa de spam)\n5. Se você tem um código de acesso, [código de acesso]({{baseUrl}}/redeem)\n\nSe nada disso se aplica, **clique aqui**",
			"restorePurchaseDialogBodyWeb": "1. Verifique se você entrou com o e-mail correto\n2. Verifique se a **[prova selecionada](/account/settings)** está correta\n3. Verifique se sua assinatura não expirou\n\nSe nada disso se aplica, **fale com o suporte**",
			"accesDuration": {
				"yearPlan": "O plano de **{{duration}}** oferece acesso estendido, proporcionando máxima flexibilidade para estudar no seu ritmo e se preparar completamente para sua prova.",
				"moreTime": "Se achar que precisará de mais tempo para estudar, considere o plano de **{{duration}}**.",
				"otherPlan": "O plano de **{{duration}}** dará acesso até **{{expiryText}}**, proporcionando tempo suficiente para estudar. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Fazer upgrade",
				"unlock": "Desbloquear por {{price}}",
				"subscribe": "Assinar por {{price}}",
				"extendAccess": "Estender acesso",
				"accessHere": "Acessar aqui",
				"redeemAccessCode": "Tem um código de acesso?",
				"restorePurchase": "Já comprou?",
				"restorePurchaseWeb": "Já comprou ou tem um código de acesso?"
			},
			"subscriptionSummary": {
				"yearly": "Assinatura anual • Renovação automática • Cancele quando quiser",
				"monthly": "Assinatura mensal • Renovação automática • Cancele quando quiser",
				"weekly": "Assinatura semanal • Renovação automática • Cancele quando quiser",
				"generic": "Assinatura com renovação automática • Cancele quando quiser"
			},
			"planDuration": {
				"day_one": "{{count}} dia",
				"day_other": "{{count}} dias",
				"week_one": "{{count}} semana",
				"week_other": "{{count}} semanas",
				"month_one": "{{count}} mês",
				"month_other": "{{count}} meses",
				"year_one": "{{count}} ano",
				"year_other": "{{count}} anos"
			},
			"recommendedPlan": {
				"plan": "Recomendamos o plano de **{{duration}}** para você se preparar melhor para sua prova em **{{date}}**",
				"subscription": {
					"yearly": "Recomendamos a **assinatura anual** para ter acesso contínuo e se preparar para sua prova em **{{date}}**",
					"monthly": "Recomendamos a **assinatura mensal** para ter acesso contínuo e se preparar para sua prova em **{{date}}**",
					"weekly": "Recomendamos a **assinatura semanal** para ter acesso contínuo e se preparar para sua prova em **{{date}}**",
					"generic": "Recomendamos uma **assinatura** para ter acesso contínuo e se preparar para sua prova em **{{date}}**"
				}
			},
			"disclaimer": "Ao confirmar a compra, você terá acesso completo ao conteúdo deste produto pelo período selecionado. Quando esse período terminar, você perderá o acesso ao conteúdo restrito. Se quiser estender seu acesso por qualquer motivo (por exemplo, se você mudou a data da sua prova), é possível adicionar tempo com compras adicionais no aplicativo. Para mais informações, consulte nossos [Termos de Serviço e Política de Privacidade](https://memorang.com/legal)."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "Com base em {{numItems}} {{item}} tentados em {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "Isso mostra seu progresso em {{count}} {{type}}. Ele se baseia em {{itemCount}} {{item}} que você tentou até agora."
		},
		"needsImprovement": {
			"title": "Precisa melhorar",
			"subtitle": "Recomendação para melhorar em {{type}}",
			"cta": "Estudar agora"
		},
		"mastery": {
			"high": "Dominado",
			"medium": "Quase lá",
			"low": "Precisa praticar",
			"count": "{{count}} {{item}} tentados",
			"zeroTooltip": "Ainda não há itens de {{label}} entre os {{total}} itens tentados",
			"highTooltip": "Você dominou {{count}} dos {{total}} {{item}} tentados",
			"mediumTooltip": "Você está progredindo em {{count}} dos {{total}} {{item}} tentados",
			"lowTooltip": "Você precisa praticar mais {{count}} dos {{total}} {{item}} tentados"
		},
		"stats": {
			"completion": "Conclusão",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "Você concluiu {{completed}} de {{total}} {{item}}"
		},
		"exams": {
			"title": "Simulados",
			"subtitle_one": "Com base em {{count}} avaliação concluída",
			"subtitle_other": "Com base em {{count}} avaliações concluídas"
		},
		"summary": {
			"title": "Resumo do aprendizado",
			"subtitle": "Com base em {{count}} {{item}} tentados",
			"tooltip": "Este resumo mostra seus níveis de domínio e progresso de conclusão em {{count}} {{item}} no total. Seu desempenho é medido por sessões de prática, avaliações e atividades de estudo.",
			"mastery": "Domínio",
			"quickStats": "Estatísticas rápidas"
		},
		"languageLearning": {
			"proficiencyCardTitle": "Proficiência em {{skill}}",
			"proficiencyCardTooltip": "No momento, você está em um nível {{level, lowercase}} de {{skill, lowercase}}",
			"itemTypesCardSubtitle_one": "{{count}} tipo de item",
			"itemTypesCardSubtitle_other": "{{count}} tipos de itens",
			"itemTypesCardTitle": "Itens de {{skill}}",
			"itemTypeLevelTooltip": "No momento, você está em um nível {{level, lowercase}} de {{skill, lowercase}} nos tipos de questão “{{itemType}}”",
			"itemTypesFallbackTitle": "Tipos de item",
			"itemTypesEmptyTitle": "Tipos de item indisponíveis",
			"itemTypesEmptySubtitle": "Não foi possível encontrar tipos de item para esta habilidade. Volte para Progresso e tente novamente.",
			"itemTypesEmptyCta": "Voltar para Progresso",
			"notAnswered": "Não respondido",
			"answeredSubtitle_one": "Com base em {{count}} item respondido",
			"answeredSubtitle_other": "Com base em {{count}} itens respondidos",
			"responsesSubtitle_one": "Com base em {{count}} resposta",
			"responsesSubtitle_other": "Com base em {{count}} respostas",
			"testsTakenSubtitle_one": "Com base em {{count}} teste realizado",
			"testsTakenSubtitle_other": "Com base em {{count}} testes realizados",
			"startFirstTest": {
				"title": "Vamos começar",
				"itemsSubtitle_one": "{{count}} item",
				"itemsSubtitle_other": "{{count}} itens",
				"guidance": {
					"diagnostic": "Comece com um diagnóstico para descobrir seus pontos fortes e ajustar seu plano de estudo.",
					"sectional": "Um teste por seção foca em uma parte do exame, então você obtém uma pontuação em uma sessão mais curta.",
					"fullMock": "Um simulado completo reproduz o exame real do início ao fim e dá a pontuação mais completa."
				}
			},
			"noScoresTitle": "Ainda não há pontuações de {{skill, lowercase}}",
			"noScoresSubtitle": "Faça seu primeiro teste para ver sua pontuação estimada e o detalhamento por tarefa.",
			"noScoresCta": "Iniciar",
			"noScoresCardSubtitle": "Com base nos testes que você realiza",
			"personalBestLabel": "Seu melhor resultado pessoal",
			"latestLabel": "Seu mais recente",
			"examCountdown_one": "Sua prova é em {{count}} dia",
			"examCountdown_other": "Sua prova é em {{count}} dias",
			"greeting": {
				"none": "Vamos começar, {{firstName}}! 🚀",
				"low": "Bom começo, {{firstName}} — continue assim! 💪",
				"medium": "Continue assim, {{firstName}}! 💪",
				"high": "Você está quase lá, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "Vamos começar! 🚀",
				"low": "Bom começo — continue assim! 💪",
				"medium": "Continue assim! 💪",
				"high": "Você está quase lá! 🎯"
			},
			"stats": {
				"untilExam": "Data da prova",
				"itemsAnswered": "Itens respondidos",
				"responsesAnswered": "Respostas"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Código de acesso incorreto",
		"incorrectPassword": "Senha incorreta. Tente novamente.",
		"passwordPlaceholder": "Digite a senha",
		"emailPlaceholder": "ex.: dave@gmail.com",
		"verify": {
			"openEmail": "Abra o e-mail para continuar",
			"signInCta": "Verificando sua conta...",
			"signUpCta": "Criando sua conta...",
			"contactSupport": "Não encontra o e-mail? Verifique sua pasta de spam ou",
			"contactSupportLink": "Fale conosco",
			"resendMagicLink": "Reenviar link mágico",
			"resendMagicLinkIn": "Reenviar link mágico em {{time}}",
			"signInBody": "Você está quase lá! Estamos verificando seus dados para entrar com segurança no aplicativo {{appName}}.",
			"signUpBody": "Quase pronto! Estamos verificando seus dados para criar sua nova conta no aplicativo {{appName}}.",
			"magicLinkEmail": "Enviamos um link mágico para **{{email}}**\nClique no link do seu e-mail para entrar com segurança.",
			"magicLinkEmailExpiry": "Este link expira em 10 minutos",
			"confirmEmail": "Confirme seu e-mail",
			"redirectingToApp": "Redirecionando para o aplicativo {{appName}}...",
			"appNotOpen": "O aplicativo não abriu? Clique no botão abaixo para abrir o aplicativo associado",
			"openApp": "Abrir aplicativo {{appName}}",
			"installAppPrompt": "Se nada acontecer, verifique se o aplicativo {{appName}} está instalado no seu dispositivo",
			"verifyAccountTitle": "Verifique sua conta",
			"emailResent": "Link mágico enviado para {{email}}\nVerifique sua caixa de entrada, incluindo o spam.",
			"verificationLinkExpired": "O link de verificação expirou",
			"verificationLinkExpiredBody": "Os links de verificação expiram após 10 minutos e só podem ser usados uma vez. \nVocê pode solicitar um novo entrando novamente.",
			"accountSetupTimeoutTitle": "Não foi possível concluir o login",
			"accountSetupTimeoutBody": "Sua conta está demorando mais do que o esperado para ser configurada. Tente entrar novamente ou fale com o suporte se isso continuar.",
			"loginAgain": "Entrar novamente",
			"contactSupportExpiredLink": "Se esse problema continuar, avise-nos",
			"successTitle": "Você já entrou em outra aba",
			"successBody": "Feche esta aba ou continue por aqui",
			"successCtaLabel": "Continuar aqui",
			"needHelpLabel": "Precisa de ajuda?",
			"contactSupportButton": "Fale conosco"
		},
		"contactSupportDialog": {
			"title": "Problemas para entrar?",
			"body": "Entre em contato com nosso suporte ao cliente se tiver problemas para entrar ou tente novamente",
			"cta": "Enviar e-mail"
		},
		"emailInstruction": {
			"default": "Se não receber um e-mail, verifique as pastas de lixo eletrônico, spam e itens excluídos recentemente",
			"edu": "Se não receber um e-mail, verifique as pastas de lixo eletrônico, spam e itens excluídos recentemente ou entre em contato com o administrador de TI"
		},
		"createSessionLoader": {
			"configuringSession": "Configurando sessão",
			"analyzingMastery": "Analisando domínio",
			"loadingContent": "Carregando conteúdo"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "Como devemos chamar você?",
				"description": "Seu nome de usuário aparece em placares públicos, enquanto seu nome permanece privado.",
				"usernameLabel": "Nome de usuário",
				"firstNameLabel": "Nome",
				"lastNameLabel": "Sobrenome",
				"avatarLabel": "Avatar",
				"avatarTooltip": "Os avatares são gerados automaticamente com base no seu nome de usuário.",
				"profileSaveFailed": "Não foi possível salvar seu perfil. Tente novamente."
			},
			"testDate": {
				"cta": "Continuar"
			},
			"examDate": {
				"daysAway": "Isso nos dá {{value}} dias. Vamos priorizar imediatamente suas áreas mais fracas."
			},
			"skills": {
				"chooseAll": "Escolha todas as opções aplicáveis"
			},
			"plan": {
				"recommended": "Recomendado"
			},
			"toeicLevelOverview": {
				"title": "Todo mundo começa de algum lugar.",
				"description": "A prática ajuda você a dominar um nível antes de avançar naturalmente para o próximo.",
				"illustrationLabel": "Progressão de Básico (A1–A2) para Intermediário (B1–B2) até Proficiente (C1).",
				"levels": {
					"basic": {
						"name": "Básico",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Intermediário",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Proficiente",
						"band": "C1"
					}
				},
				"progression": {
					"title": "Como você vai progredir",
					"practiceSessions": "Pratique as sessões recomendadas",
					"buildMastery": "Desenvolva domínio no seu nível atual",
					"growToward": "Continue evoluindo rumo a Proficiente"
				},
				"levelDetails": {
					"title": "O que cada nível significa",
					"scoreRange": "{{band}} · pontuação {{min}}–{{max}}",
					"basic": {
						"name": "Usuário básico",
						"summary": "Inglês simples para o trabalho",
						"examples": {
							"forms": "Formulários e avisos",
							"instructions": "Instruções",
							"announcements": "Anúncios curtos"
						}
					},
					"intermediate": {
						"name": "Usuário intermediário",
						"summary": "Comunicação cotidiana no trabalho",
						"examples": {
							"emails": "E-mails e conversas",
							"customers": "Interações com clientes",
							"followUps": "Acompanhamentos de reuniões"
						}
					},
					"proficient": {
						"name": "Usuário proficiente",
						"summary": "Inglês profissional e avançado",
						"examples": {
							"reports": "Relatórios e apresentações complexos",
							"negotiations": "Negociações sutis",
							"highStakes": "Contextos profissionais críticos"
						}
					}
				},
				"disclaimer": "As pontuações do TOEIC Link são referências alinhadas ao CEFR, não notas de corte absolutas. Reading e Listening progridem de forma independente — você pode alcançar níveis diferentes em cada habilidade."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Diagnóstico: {{title}}",
					"body": "{{count}} itens para descobrir onde focar",
					"duration": "{{minutes}} min"
				},
				"homeChoice": {
					"title": "Explorar por conta própria",
					"body": "Ainda não quero começar, vou explorar o app primeiro"
				}
			}
		},
		"common": {
			"changeLater": "Você pode alterar isso mais tarde"
		},
		"actions": {
			"previous": "Anterior",
			"finish": "Concluir",
			"start": "Começar",
			"continue": "Continuar",
			"stepIndicator": "Etapa {{step}} de {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "Sobre você"
		},
		"exam": {
			"title": "Sua prova"
		},
		"subscriptions": {
			"title": "Produtos",
			"redeem": {
				"title": "Resgatar compra"
			},
			"extend": {
				"cta": "Estender"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Defina a data da sua prova",
			"description": "Esta data serve apenas para orientar seu cronograma de estudos no app. Ela não afeta sua inscrição oficial na prova.",
			"dismissCta": "Agora não",
			"confirmCta": "Definir data da prova"
		}
	},
	"account": {
		"title": "Minha conta",
		"currentExam": "Prova atual",
		"subscriptions": "Direitos de acesso",
		"examDate": "Data da prova",
		"examDateUpdated": "Data da prova definida para {{date}}",
		"selectDate": "Selecionar data",
		"appearance": "Aparência",
		"features": "Recursos",
		"audioPlaybackTest": "Mostrar diálogo de reprodução de áudio de teste",
		"theme": "Tema",
		"selectTheme": "Escolher tema",
		"themeOptions": {
			"system": "Sistema",
			"light": "Claro",
			"dark": "Escuro"
		},
		"accountInfo": "Conta",
		"username": "Nome de usuário",
		"name": "Nome",
		"nameNotSet": "Não definido",
		"save": "Salvar",
		"editUsername": {
			"title": "Editar nome de usuário"
		},
		"editName": {
			"title": "Editar nome"
		},
		"email": "E-mail",
		"dev": "Desenvolvimento",
		"sandbox": "Sandbox",
		"redoOnboarding": "Refazer a introdução",
		"about": "Sobre",
		"termsOfService": "Termos de serviço",
		"privacyPolicy": "Política de privacidade",
		"aiToolsTos": "Termos de uso das ferramentas de IA",
		"support": "Suporte",
		"supportEmailBody": "Estou entrando em contato porque preciso de ajuda com [  ]\n\n\n\nAqui estão algumas informações úteis para resolver a situação mais rapidamente: \n\nNome de usuário associado à conta (encontrado nas configurações ao entrar no aplicativo):\n{{username}}\n\nE-mail associado ao meu pedido (encontrado nas configurações ao entrar no aplicativo):\n{{email}}\n\nNúmero do pedido (geralmente encontrado no e-mail de recibo enviado após a compra):\n\nHá alguma possibilidade de um nome ou e-mail diferente ter sido usado quando o produto foi comprado? Se sim, informe-os:\n\nNome e sobrenome:\n\nE-mail:",
		"contactSupport": "Falar com o suporte",
		"signOut": "Sair",
		"signOutConfirmation": "Tem certeza de que deseja sair?",
		"deleteAccount": "Excluir conta",
		"platform": "Plataforma",
		"partnerships": "Parcerias",
		"validUntil": "Expira em {{date}}",
		"extendValidity": "Estender acesso",
		"redeemPurchase": "Resgatar compra",
		"redeemPurchaseNoneFound": "Nenhuma compra disponível para resgatar",
		"redeemPurchaseCheckFailed": "Não foi possível verificar as compras. Tente novamente.",
		"purchases": "Compras",
		"frequentlyAskedQuestions": "Perguntas frequentes",
		"deleteFeedbackForm": {
			"placeholder": "Comentários"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "Dados insuficientes",
		"proficiencyLevelPendingTooltip": "Responda mais itens de {{label}} para estimar seu nível",
		"on": "em",
		"gotIt": "Entendi",
		"goBack": "Voltar",
		"topic": "tópico",
		"itemCount_one": "{{count}} item",
		"itemCount_other": "{{count}} itens",
		"examCount_one": "{{count}} prova",
		"examCount_other": "{{count}} provas",
		"questionCount_one": "{{count}} questão",
		"questionCount_other": "{{count}} questões",
		"item_one": "item",
		"item_other": "itens",
		"and": "e",
		"this": "isto",
		"of": "de",
		"knowMore": "Saiba mais",
		"proficiency": "proficiência",
		"didNotAnswer": "Itens que você ainda não tentou",
		"notAnswered": "Não respondido",
		"attempted": "tentado",
		"attempt": "tentativa",
		"activity": "atividade",
		"performance": "Desempenho",
		"estimatedProficiency": "Proficiência estimada",
		"details": "detalhes",
		"keepPracticing": "continue praticando!",
		"leaveFeedback": "Deixar comentário",
		"copiedToClipboard": "Copiado para a área de transferência",
		"eg": "ex.",
		"set": "definir",
		"hint": "dica",
		"itemType": "tipo de item",
		"minute": "minuto",
		"minutes": "{{count}} minutos",
		"hour": "hora",
		"hours": "{{count}} horas",
		"continue": "Continuar",
		"unlock": "Desbloquear",
		"cancel": "Cancelar",
		"view": "Ver",
		"switch": "Trocar",
		"update": "Atualizar",
		"ok": "Ok",
		"yes": "Sim",
		"free": "Grátis",
		"answered": "Respondido",
		"correct": "Correto",
		"incorrect": "Incorreto",
		"marked": "Marcado",
		"unmarked": "Não marcado",
		"skipped": "Pulado",
		"skill_one": "habilidade",
		"skill_other": "habilidades",
		"word_one": "palavra",
		"word_other": "palavras",
		"submitResponse": "Enviar resposta",
		"viewDetails": "Ver detalhes",
		"sec_one": "s",
		"sec_other": "s",
		"point_one": "ponto",
		"point_other": "pontos",
		"week": "Semana",
		"month": "Mês",
		"year": "Ano",
		"day": "Dia",
		"selectTestDate": "Selecionar data da prova",
		"points": "Pontos",
		"viewAll": "Ver tudo",
		"timeline": "Linha do tempo",
		"save": "Salvar",
		"filters": {
			"selectAll": "Selecionar tudo",
			"deselectAll": "Desmarcar tudo",
			"selectedCount": "{{count}} selecionadas",
			"expandSection": "Expandir {{section}}",
			"collapseSection": "Recolher {{section}}"
		},
		"showMore": "Mostrar mais",
		"showLess": "Mostrar menos",
		"expandA11yLabel": "Expandir descrição",
		"collapseA11yLabel": "Recolher descrição",
		"done": "Concluído",
		"clearAll": "Limpar tudo",
		"clear": "Limpar",
		"datePicker": {
			"title": "Selecionar data",
			"enterDateLabel": "Inserir data",
			"enterDateRangeLabel": "Inserir datas",
			"dateLabel": "Data",
			"startDateLabel": "Data de início",
			"endDateLabel": "Data de término",
			"dateRequiredError": "A data é obrigatória",
			"invalidDateFormatError": "Formato de data inválido. Use MM/DD/YYYY",
			"startAfterEndError": "A data de início não pode ser posterior à data de término",
			"endBeforeStartError": "A data de término não pode ser anterior à data de início",
			"minDateError": "A data deve ser {{date}} ou posterior",
			"maxDateError": "A data deve ser {{date}} ou anterior",
			"dateRangeError": "A data deve estar entre {{startDate}} e {{endDate}}",
			"setDateCta": "Definir data",
			"nextCta": "Próximo",
			"setTimeCta": "Definir horário"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}} dos alunos escolheram esta resposta.",
		"choiceCorrectA11yLabel": "Resposta correta",
		"choiceIncorrectA11yLabel": "Resposta incorreta",
		"choiceNotSelectedA11yLabel": "Não selecionada",
		"moreItemsAlertDialog": {
			"title": "Itens adicionais",
			"cta": "Entendi"
		},
		"results": {
			"followUps": {
				"title": "Acompanhamentos"
			},
			"summary": {
				"sessionAnalysis": "Análise da sessão",
				"itemCount_one": "{{count}} item",
				"itemCount_other": "{{count}} itens",
				"skilledItemCount_one": "{{count}} item de {{skills}}",
				"skilledItemCount_other": "{{count}} itens de {{skills}}",
				"levelPhrase_one": "do nível {{levels}}",
				"levelPhrase_other": "dos níveis {{levels}}",
				"message": "<bold>Ótimo trabalho!</bold> Você acabou de concluir {{itemPhrase}} em {{timeTaken}}.",
				"messageWithLevels": "<bold>Ótimo trabalho!</bold> Você acabou de concluir {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) em {{timeTaken}}.",
				"proficiencyEstimateReady": "Seu nível estimado de {{skill}} é <bold>{{currentLevel}}</bold>. Agora você está pronto para avançar para <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateKeepPracticing": "Seu nível estimado de {{skill}} é <bold>{{currentLevel}}</bold>. Continue praticando antes de avançar para <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateHighest": "Seu nível estimado de {{skill}} é <bold>{{currentLevel}}</bold>. Trabalho excepcional!",
				"mixedLevel": "Misto",
				"overallScore": "Pontuação geral",
				"stats": {
					"itemsAttempted_one": "Item tentado",
					"itemsAttempted_other": "Itens tentados",
					"pointsEarned_one": "Ponto ganho",
					"pointsEarned_other": "Pontos ganhos",
					"answeredCorrectly": "Respondido corretamente",
					"timeTaken": "Tempo gasto",
					"target": "Meta",
					"ofTotal": "de {{total}}",
					"ofPointsTotal": "de {{total}}",
					"skill": "Habilidade",
					"skills": "Habilidades",
					"questionType": "Tipo de questão",
					"questionTypes": "Tipos de questão",
					"proficiencyLevel": "Nível de proficiência",
					"proficiencyLevels": "Níveis de proficiência"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "O áudio começa em {{seconds}}s",
			"audioStartsInPlayOnce": "O áudio começa em {{seconds}}s e será reproduzido apenas uma vez",
			"videoStartsIn": "O vídeo começa em {{seconds}}s",
			"videoStartsInPlayOnce": "O vídeo começa em {{seconds}}s e será reproduzido apenas uma vez",
			"recordingIn": "A gravação começa em {{seconds}}s"
		},
		"timeOverrunBanner": {
			"message": "O tempo acabou. Na prova real, nada após este ponto seria pontuado. Você pode continuar praticando."
		},
		"attributes": {
			"stimulus": "estímulo"
		},
		"stimulusTypes": {
			"reading": "Leitura",
			"listening": "Compreensão auditiva",
			"speaking": "Expressão oral",
			"writing": "Escrita",
			"image": "Imagem"
		},
		"masteryLevels": {
			"belowBasic": "Abaixo do básico",
			"basic": "Básico",
			"belowLowIntermediate": "Abaixo do intermediário baixo",
			"lowIntermediate": "Intermediário baixo",
			"highIntermediate": "Intermediário alto",
			"advanced": "Avançado",
			"proficiencySubtitle": "No {{trademark}}, isso corresponde a uma pontuação de **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "Informações da seção de {{skill}}",
			"infoSectionText": {
				"Reading": "A seção de Leitura do {{trademark}} avalia sua capacidade de ler e compreender materiais escritos usados em um ambiente acadêmico. Ela inclui duas passagens de leitura, cada uma com aproximadamente 700 palavras e 10 questões por passagem. A conclusão da seção de Leitura deve levar cerca de 35 minutos.",
				"Listening": "A seção de Compreensão auditiva do {{trademark}} foi desenvolvida para medir sua capacidade de compreender conversas e palestras em inglês. Ela inclui a avaliação de: compreensão básica, entendimento da atitude e do grau de certeza do falante e conexão de informações. A conclusão da seção de Compreensão auditiva deve levar cerca de 36 minutos.",
				"Speaking": "A seção de Expressão oral do {{trademark}} mede sua capacidade de falar inglês de forma eficaz em contextos acadêmicos. As quatro questões/tarefas se assemelham a situações reais que você pode encontrar dentro e fora de uma sala de aula. A conclusão da seção de Expressão oral deve levar cerca de 16 minutos.",
				"Writing": "A seção de Escrita da prova {{trademark}} mede sua capacidade de escrever em inglês em um contexto acadêmico e de apresentar suas ideias de maneira clara e bem organizada. Você digitará suas respostas em um teclado de computador, e a conclusão da seção de Escrita deve levar cerca de 29 minutos."
			}
		},
		"itemTypes": {
			"MCSS": "Múltipla escolha com seleção única",
			"MCSSH": "Múltipla escolha com seleção única e destaque",
			"MCMS": "Múltipla escolha com seleção múltipla",
			"MCMSH": "Múltipla escolha com seleção múltipla e destaque",
			"INSERT_TEXT": "Inserir texto",
			"MATCH_MS": "Correspondência com seleção múltipla",
			"MCSSM": "Múltipla escolha com seleção única e correspondência",
			"MCMSM": "Múltipla escolha com seleção múltipla e correspondência",
			"MCGS": "Múltipla escolha com seleção de lacuna",
			"MCOS": "Múltipla escolha com ordenação",
			"LISTENING_REPLAY": "Reproduzir áudio novamente",
			"AUDIO_INPUT": "Entrada de áudio",
			"ACADEMIC_DISCUSSION_RESPONSE": "Resposta para discussão acadêmica",
			"INTEGRATED_WRITING_RESPONSE": "Resposta de escrita integrada"
		},
		"passageStem": {
			"itemOfTotal": "Item {{current}} de {{total}}",
			"questionOfTotal": "Pergunta {{current}} de {{total}}",
			"stimulusCorrespondsToNextItems": "O estímulo a seguir corresponde aos próximos {{total}} itens",
			"passage": "Passagem",
			"lecture": "Palestra",
			"professorsQuestion": "Pergunta do professor",
			"listen": "Ouvir",
			"openPassage": "Abrir passagem",
			"backToItem": "Voltar ao item",
			"notYetInserted": "Ainda não inserido",
			"insertedAtPosition": "Inserido na posição #{{position}}"
		},
		"hint": {
			"show": "Mostrar dica"
		},
		"navigation": {
			"next": "Próximo",
			"exit": "Sair",
			"saveAndExit": "Salvar e sair",
			"previous": "Anterior",
			"skip": "Pular",
			"finish": "Finalizar",
			"help": "Ajuda",
			"about": "Dicas da questão",
			"questionsButtonLabel": "Navegação por questões",
			"questionsButtonTooltip": "Vá para qualquer questão ou revise as questões marcadas",
			"questionsButtonActiveFiltersA11y": "Filtros ativos: {{count}}",
			"recordingInProgressTooltip": "Você não pode sair deste item enquanto a gravação estiver em andamento",
			"questionNotReachedTooltip": "Você ainda não chegou a esta pergunta"
		},
		"questionTips": {
			"hideFutureLabel": "Não mostrar dicas automaticamente"
		},
		"toolbar": {
			"calculatorTooltip": "Abrir calculadora",
			"highlightTooltip": "Selecione um texto para destacar informações importantes e consultá-las facilmente",
			"markTooltip": "Marque esta questão para revisá-la mais tarde antes de enviar",
			"unmarkTooltip": "Clique para desmarcar esta questão"
		},
		"summary": {
			"viewFullInsights": "Ver insights completos",
			"targetTooltip": "A meta de desempenho para esta sessão."
		},
		"stats": {
			"skill": "Habilidade",
			"answered": "Respondidas",
			"speed": "Velocidade",
			"duration": "Duração",
			"duration_tooltip": "A duração da sua resposta gravada: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Confiança",
			"pointsEarned": "Pontos",
			"word": "Palavra",
			"words": "Palavras",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "Você levou {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) para ler e responder a este item",
			"skill_tooltip": "A área de habilidade avaliada neste item: {{skill}}",
			"answered_correct_tooltip": "Sua resposta enviada estava correta",
			"answered_incorrect_tooltip": "Sua resposta enviada estava incorreta",
			"skipped_tooltip": "Você não enviou uma resposta para este item",
			"words_tooltip": "Contagem de palavras em sua resposta escrita: {{count}}",
			"word_tooltip": "Contagem de palavras em sua resposta escrita: {{count}}",
			"confidence_tooltip": "Seu nível de confiança ao enviar sua resposta",
			"points_earned_tooltip_one": "Você obteve {{points}} ponto de um máximo de {{maximumScore}} pontos neste item",
			"points_earned_tooltip_other": "Você obteve {{points}} pontos de um máximo de {{maximumScore}} pontos neste item",
			"challengers_tooltip": "Número de estudantes que tentaram responder a este item antes de você: {{count}}",
			"learning_mode_points_tooltip": "Pontos obtidos nesta tentativa: +{{xp}} XP",
			"pts_earned_tooltip": "Pontos obtidos nesta tentativa: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Expandir detalhamento"
		},
		"explanation": {
			"title": "Explicação",
			"feedback": "Feedback",
			"skippedFeedbackNotice": "Você pulou esta questão, portanto não foi gerado um feedback personalizado."
		},
		"followUps": "Acompanhamentos",
		"suggestCorrection": "Sugerir correção",
		"answer": {
			"correct": "Correta",
			"incorrect": "Incorreta",
			"skipped": "Ignorada"
		},
		"confidence": {
			"high": "Alta",
			"medium": "Média",
			"low": "Baixa"
		},
		"endDialog": {
			"title": "Finalizar a sessão antes do término?",
			"confirmEndDiagnostic": "Tem certeza de que deseja encerrar sua sessão? Todo o progresso será perdido e você precisará recomeçar.",
			"confirmEnd": "Você ainda tem {{num}} {{itemLabel}} restantes. Pode finalizar agora ou continuar estudando para concluí-los.",
			"confirmEndNoAnswer": "Você ainda não respondeu a nenhuma questão. Tem certeza de que deseja finalizar agora?",
			"confirmEndNoAnswerPositive": "Continuar estudando",
			"confirmEndNoAnswerNegative": "Finalizar agora"
		},
		"permissionDialog": {
			"title": "Acesso ao microfone necessário",
			"descriptionWeb": "A prática de fala usa seu microfone. Seu navegador está bloqueando o acesso para este site — clique no ícone de permissões ao lado do endereço da web, permita o microfone e tente novamente.",
			"descriptionMobile": "A prática de fala usa seu microfone. Permita o acesso ao microfone nas configurações do dispositivo para continuar.",
			"promptDescriptionWeb": "A prática de fala usa seu microfone. Solicite a permissão e escolha Permitir quando o navegador perguntar.",
			"blockedDescriptionWeb": "O acesso ao microfone está bloqueado para este site. Clique no ícone ao lado do endereço da web, permita o microfone e solicite a permissão novamente.",
			"ok": "OK",
			"cancel": "Cancelar",
			"openSettings": "Abrir configurações",
			"requestPermission": "Solicitar permissão",
			"dismissAndExit": "Dispensar e sair",
			"learnMore": "Saiba mais"
		},
		"audioPlaybackTestDialog": {
			"title": "Testar reprodução de áudio",
			"description": "O aplicativo {{appName}} inclui diversos recursos de reprodução de áudio, como os usados em estímulos, itens da prova e conversão de texto em fala. Para garantir a melhor experiência, teste o áudio abaixo. Depois de confirmar que ele está funcionando, prossiga.",
			"troubleshooting": {
				"title": "Solução de problemas de áudio",
				"volumeTitle": "Verificar o volume do dispositivo",
				"volumeDescriptionWeb": "Ajuste o volume usando os controles do teclado ou as configurações de volume do sistema no menu/barra de tarefas",
				"volumeDescriptionMobile": "Use os botões de volume do dispositivo ou ajuste-o nas configurações do sistema",
				"outputTitle": "Verificar o dispositivo de saída de áudio",
				"outputDescription": "Se estiver usando fones de ouvido, certifique-se de que estejam conectados corretamente e selecionados como dispositivo de saída ativo",
				"browserTitle": "Verificar o áudio da aba do navegador",
				"browserDescription": "Procure o ícone de alto-falante silenciado ao lado do título da aba e ative o áudio, se ele estiver presente."
			},
			"skipCheck": "Pular esta verificação da próxima vez",
			"workingButton": "Confirmar áudio",
			"textToHear": "Você deve ouvir: {{text}}"
		},
		"overall": "Geral",
		"subskills": {
			"content": {
				"title": "Conteúdo"
			},
			"languageUse": {
				"title": "Uso da linguagem"
			},
			"organizationAndDevelopment": {
				"title": "Organização e desenvolvimento"
			},
			"topicDevelopment": {
				"title": "Desenvolvimento do tema"
			},
			"delivery": {
				"title": "Apresentação"
			}
		},
		"finalizing": {
			"title": "Finalizando seus resultados",
			"gradingProgress": "Avaliando respostas..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "Uma tarefa de fala em que o aluno repete uma frase ouvida com a maior precisão possível.",
			"Read Aloud": "Um item de fala em que o aluno lê um trecho em voz alta para avaliação.",
			"Describe Image": "Uma tarefa de fala em que o aluno descreve em detalhes um estímulo visual.",
			"Write Essay": "Uma tarefa de resposta escrita que exige uma redação estruturada sobre um tema dado.",
			"Retell Lecture": "Uma tarefa de fala em que o aluno resume uma palestra ou apresentação que ouviu.",
			"Summarize Group Discussion": "Uma tarefa de compreensão auditiva em que o aluno resume uma discussão com vários participantes.",
			"Answer Short Question": "Uma breve tarefa de fala em que se responde a uma única pergunta curta de forma concisa.",
			"Respond to a Situation": "Uma tarefa de fala em que o aluno responde de forma adequada a uma situação descrita.",
			"Summarize Written Text": "Uma tarefa de leitura em que o aluno resume um trecho com as próprias palavras.",
			"Reorder Paragraph": "Uma tarefa de leitura em que o aluno organiza parágrafos embaralhados na ordem correta.",
			"Fill in the Blanks (Dropdown)": "Uma tarefa de leitura em que cada lacuna é preenchida a partir de uma lista suspensa de opções.",
			"Fill in the Blanks (Type In)": "Uma tarefa de compreensão auditiva em que o aluno digita a palavra ou expressão curta que falta.",
			"Fill in the Blanks (Drag and Drop)": "Uma tarefa de leitura em que as palavras que faltam são preenchidas arrastando opções para as lacunas.",
			"Multiple Choice, Single Answer": "Um item de múltipla escolha em que o aluno seleciona uma resposta correta.",
			"Multiple Choice, Single Answer (Reading)": "Um item de múltipla escolha de leitura em que o aluno seleciona uma resposta correta.",
			"Multiple Choice, Single Answer (Listening)": "Um item de múltipla escolha de compreensão auditiva em que o aluno seleciona uma resposta correta.",
			"Multiple Choice, Multiple Answers": "Um item em que o aluno pode selecionar mais de uma resposta correta.",
			"Multiple Choice, Multiple Answers (Reading)": "Um item de leitura em que o aluno pode selecionar mais de uma resposta correta.",
			"Multiple Choice, Multiple Answers (Listening)": "Um item de compreensão auditiva em que o aluno pode selecionar mais de uma resposta correta.",
			"Summarize Spoken Text": "Uma tarefa de compreensão auditiva em que o aluno escreve um resumo do que ouviu.",
			"Highlight Correct Summary": "Uma tarefa de compreensão auditiva em que o aluno destaca o resumo que melhor corresponde ao áudio.",
			"Select Missing Word": "Uma tarefa de compreensão auditiva no estilo lacuna em que o aluno escolhe a palavra que falta.",
			"Highlight Incorrect Words": "Uma tarefa de compreensão auditiva em que o aluno destaca as palavras da transcrição que diferem do áudio.",
			"Write from Dictation": "Uma tarefa de compreensão auditiva em que o aluno transcreve uma frase que ouve."
		}
	},
	"report": {
		"readFullInsights": "Ler insights completos",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Iniciado às {{time}}",
		"itemTypesTitle": "Detalhamento dos tipos de item",
		"itemTypesFilterAll": "Todos",
		"questionTypeCardTitle": "Detalhamento dos tipos de item de {{skill}}",
		"questionTypeCardSubtitle_one": "Com base em {{count}} tipo de item de {{skill}} nesta sessão",
		"questionTypeCardSubtitle_other": "Com base em {{count}} tipos de item de {{skill}} nesta sessão",
		"questionTypeCardAltSubtitle_one": "{{count}} tipo",
		"questionTypeCardAltSubtitle_other": "{{count}} tipos",
		"questionTypeRowSubtitle_zero": "Nenhum item respondido",
		"questionTypeRowSubtitle_one": "{{count}} item respondido",
		"questionTypeRowSubtitle_other": "{{count}} itens respondidos",
		"itemTypeDetail": {
			"review_one": "Revisar item",
			"review_other": "Revisar itens",
			"stats": {
				"answered_one": "Item respondido",
				"answered_other": "Itens respondidos",
				"avgTime": "Tempo médio por item"
			}
		},
		"reviewAnswersDialog": {
			"title": "Revisar respostas",
			"sections": {
				"skills": "Habilidades",
				"questionTypes": "Tipos de questão",
				"proficiency": "Proficiência",
				"performance": "Desempenho"
			},
			"summaryNone": "Selecione filtros com itens para continuar.",
			"summaryAll_one": "Revise {{count}} resposta.",
			"summaryAll_other": "Revise todas as {{count}} respostas.",
			"summaryFiltered_one": "Revise {{count}} resposta correspondente a {{filters}}.",
			"summaryFiltered_other": "Revise {{count}} respostas correspondentes a {{filters}}.",
			"reviewAnswers_one": "Revisar {{count}} resposta",
			"reviewAnswers_other": "Revisar {{count}} respostas",
			"more": "mais {{count}}"
		},
		"itemDetail": {
			"title": "Revisar minhas respostas",
			"filterAll": "Todos",
			"filterCorrect": "Corretos",
			"filterIncorrect": "Incorretos",
			"filterMarked": "Marcados",
			"emptyTitle": "Nenhum item correspondente",
			"emptyDescription": "Nenhum item da sua sessão corresponde ao filtro selecionado ({{filter}}). Ajuste ou limpe os filtros para ver mais resultados.",
			"emptyCta": "Limpar filtros"
		},
		"answerCardTitle": "Revisão do item",
		"answerCardSubtitle_one": "Com base em {{count}} item",
		"answerCardSubtitle_other": "Com base em {{count}} itens",
		"skillsBreakdown": {
			"title": "Detalhamento das habilidades",
			"subtitle_one": "Com base em {{count}} item",
			"subtitle_other": "Com base em {{count}} itens"
		},
		"studyPack": "Study-Pack",
		"practiceTestCompleted": "Simulado concluído",
		"studySessionCompleted": "Sessão de estudo concluída",
		"diagnosticSessionCompleted": "Sessão de diagnóstico concluída",
		"timeElapsed": "Tempo decorrido",
		"stats": {
			"answered": "RESPONDIDOS",
			"time elapsed": "TEMPO DECORRIDO",
			"avg speed": "VELOCIDADE MÉDIA",
			"hints used": "DICAS USADAS"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Trabalho fantástico — continue buscando a excelência!",
				"highIntermediate": "Você está indo muito bem — continue aprimorando seus pontos fortes!",
				"lowIntermediate": "Seu progresso é constante — continue assim!",
				"basic": "Continue praticando para desenvolver suas habilidades!"
			},
			"infoText": "Você concluiu **{{numActivities}} {{activityLabel}}** para praticar {{skillsText}} {{skills}}. {{skillDetails}}. No total, você obteve **{{numPointsEarned}} de {{numTotalPoints}} pontos**, o que sugere uma proficiência **{{compositeLevel}}** em {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "Você concluiu **{{itemCount}} {{itemLabel}}** com foco na habilidade de **{{skill_1}}**. Sua pontuação foi **{{skill_1_score}} de {{skill_1_total}}**, indicando proficiência **{{proficiency}}**. {{compositeFeedback}}",
			"infoText.multiSkill": "Você concluiu **{{itemCount}} {{itemLabel}}**, praticando as habilidades de **{{skills_text}}**. {{skill_details}} No total, você obteve **{{overall_score}} de {{overall_total}} pontos**, o que sugere proficiência **{{overall_proficiency}}** nessas habilidades. {{compositeFeedback}}",
			"skillDetails": "Em **{{skill}}**, sua pontuação foi **{{score}} de {{total}}**, demonstrando proficiência **{{proficiency}}**."
		},
		"actions": {
			"goToHome": "Ir para a página inicial",
			"studyMore": "Estudar mais",
			"studyFree": "Estudar {{tagTypes}} grátis",
			"reviewAnswers": "Revisar respostas"
		},
		"nextAction": {
			"title": "Recomendado: prática de {{focus}}",
			"dialog": {
				"title": "Sessão de estudo recomendada",
				"subtitle": "Foque nos seus pontos fracos"
			},
			"fallback": {
				"title": "Continue praticando",
				"description": "Crie uma sessão de estudo com as áreas que você quer praticar a seguir."
			}
		},
		"premium": {
			"upgradeCta": "Fazer upgrade para Premium"
		},
		"disclaimer": {
			"title": "Aviso legal",
			"summativeBody": "As pontuações dos simulados são estimativas e não garantem o mesmo resultado em uma prova oficial do {{examName}}. As pontuações reais podem variar conforme as condições da prova e os critérios oficiais de correção."
		},
		"performance": {
			"title": "Desempenho",
			"subtitle": "Com base em {{count}} itens",
			"correct": "Corretos",
			"correctItems": "{{count}} itens",
			"incorrect": "Incorretos",
			"incorrectItems": "{{count}} itens"
		},
		"mastery": {
			"performanceTitle": "Desempenho",
			"sessionMasteryTitle": "Proficiência estimada",
			"subtitle_assessment": "Com base em todos os {{count}} {{item}} desta avaliação",
			"subtitle_session": "Com base em todos os {{count}} {{item}} desta sessão"
		},
		"sessionAnalysis": {
			"title": "Análise da sessão",
			"subtitle": "Análise e recomendações personalizadas",
			"viewFullAnalysis": "Ver análise",
			"feedbackDialog": {
				"body": "Lançamos atualizações quase todos os dias e estamos determinados a melhorar. Você poderia deixar seu feedback?",
				"placeholder": "Digite seu feedback aqui",
				"cta": "Enviar feedback",
				"successMessage": "Feedback enviado. Agradecemos!",
				"feedbackLimitError": "O feedback deve ter pelo menos 10 caracteres"
			},
			"menuActions": {
				"copy": "Copiar",
				"altCopy": "Copiar texto do resumo",
				"altPositiveFeedback": "Isso foi útil",
				"positiveFeedback": "Boa resposta",
				"negativeFeedback": "Resposta ruim",
				"reportIssue": "Denunciar",
				"altReportIssue": "Denunciar esta resposta",
				"emailSummary": "Enviar texto do resumo por e-mail",
				"emailAlreadySent": "E-mail já enviado",
				"copiedAnalysis": "Análise copiada para a área de transferência",
				"emailSent": "E-mail enviado para {{email}}. Se não receber o e-mail, verifique as pastas de lixo eletrônico, spam e itens excluídos recentemente",
				"emailFailed": "Não foi possível enviar o e-mail para {{email}}",
				"emailInstructionMessage": "Se não receber o e-mail, verifique as pastas de lixo eletrônico, spam e itens excluídos recentemente ou entre em contato com o administrador de TI"
			}
		}
	},
	"feedback": {
		"successMessage": "Feedback enviado. Agradecemos!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "Do que você gosta? O que poderia melhorar? Fazemos melhorias diárias na plataforma, e nossa equipe lê todos os feedbacks. Agradecemos!",
			"title": "Compartilhe seu feedback",
			"body": "Do que você gosta? O que poderia melhorar? Fazemos melhorias diárias na plataforma, e nossa equipe lê todos os feedbacks. **Agradecemos!**",
			"positiveBody": "Que bom que isso foi útil! Conte para nós **do que você gostou.**",
			"negativeBody": "Ajude-nos a entender o que deu errado para que possamos **melhorar nossas respostas.**",
			"placeholder": "Digite seu feedback",
			"cta": "Enviar feedback"
		},
		"report": {
			"title": "Enviar denúncia",
			"body": "Ajude-nos a entender o que há de errado com esta resposta",
			"cta": "Enviar denúncia"
		},
		"suggestCorrection": {
			"title": "Sugerir uma correção",
			"body": "Ajude-nos a melhorar a precisão deste conteúdo **informando qualquer erro.**",
			"cta": "Enviar"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Imprecisa",
					"description": "A resposta contém informações incorretas"
				},
				"notHelpful": {
					"title": "Não foi útil",
					"description": "A resposta não esclareceu minha dúvida"
				},
				"incomplete": {
					"title": "Incompleta",
					"description": "Faltam detalhes importantes na resposta"
				},
				"hardToUnderstand": {
					"title": "Difícil de entender",
					"description": "A resposta estava confusa ou pouco clara"
				},
				"other": {
					"title": "Outro",
					"description": "Outro motivo"
				}
			},
			"report": {
				"misinformation": {
					"title": "Informação falsa",
					"description": "A resposta contém informações falsas ou enganosas"
				},
				"harmfulContent": {
					"title": "Conteúdo nocivo ou ofensivo",
					"description": "Discurso de ódio, assédio ou linguagem imprópria"
				},
				"violatesPolicies": {
					"title": "Viola as políticas",
					"description": "Spam, autopromoção ou conteúdo ilegal"
				},
				"other": {
					"title": "Outro",
					"description": "Descreva com suas próprias palavras o que deu errado"
				}
			}
		},
		"faqs": {
			"title": "Perguntas frequentes",
			"body": "Veja algumas das perguntas mais frequentes sobre o app. Se tiver qualquer outra dúvida, entre em contato pelo e-mail support@memorang.ai"
		},
		"delete": {
			"title": "Excluir conta",
			"body": "Sentimos muito que você esteja indo embora e desejamos sucesso em sua jornada acadêmica e profissional!",
			"options": "Muito caro|Já fiz minha prova|Não gostei do conteúdo|Faltam recursos/funcionalidades|Outro",
			"confirmdelete": {
				"title": "Confirmar exclusão da conta",
				"cta": "Excluir",
				"errorMessage": "Esse e-mail não corresponde a esta conta. Tente novamente",
				"successMessage": "Conta excluída com sucesso!",
				"validEmail": "Digite um endereço de e-mail válido"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Toque para gravar sua resposta",
		"responseAudioUnavailable": "O áudio da resposta não está disponível para reprodução",
		"recording": "Gravando",
		"recordingCompleted": "Gravação concluída",
		"getReady": "Prepare-se",
		"timeIsUp": "O tempo acabou. Sua resposta não foi gravada.",
		"alert": {
			"title": "Duração máxima atingida",
			"body": "A gravação foi interrompida porque atingiu a duração máxima de {{maxDuration}} segundos."
		},
		"uiElementPressed": "Gravação interrompida — o estímulo foi aberto durante uma gravação ativa."
	},
	"writing": {
		"placeholder": "Escreva sua resposta aqui...",
		"wordCount": "{{count}} {{word}}",
		"title": "Sua resposta",
		"submit": "Enviar",
		"helper": {
			"range": "Escreva de {{min}} a {{max}} palavras para enviar sua resposta",
			"min": "Escreva pelo menos {{min}} palavras para enviar sua resposta",
			"max": "Reduza sua resposta para no máximo {{max}} palavras"
		}
	},
	"navbar": {
		"home": "Início",
		"progress": "Progresso",
		"insights": "Insights",
		"leaderboard": "Classificação",
		"store": "Loja",
		"more": "Mais",
		"redeem": "Resgatar",
		"study-pack": "Study-Pack",
		"podcasts": "Podcasts",
		"modules": "Módulos",
		"account": "Minha conta",
		"accountTab": "Conta",
		"privacy": "Privacidade",
		"terms": "Termos",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "Digitou o código corretamente e ainda está com problemas? **Fale com o suporte** e inclua seu código de acesso e os detalhes da compra",
		"olxDialog": {
			"unlockedTitle": "Acesso desbloqueado",
			"expiredTitle": "Acesso expirado",
			"testInfo": "**Exame:** {{examName}} | **Teste:** {{bundleName}}",
			"upcomingBody_one": "Seu acesso ao teste OLX foi desbloqueado!\n\nVocê poderá iniciar sua sessão em **{{count}} dia**. Volte mais tarde para começar sua sessão na aba Testes práticos.",
			"upcomingBody_other": "Seu acesso ao teste OLX foi desbloqueado!\n\nVocê poderá iniciar sua sessão em **{{count}} dias**. Volte mais tarde para começar sua sessão na aba Testes práticos.",
			"activeBody": "Seu acesso ao teste OLX já está ativo!\n\nVocê pode iniciar sua sessão a qualquer momento antes de **{{date}}**.\n\nDeseja começar sua sessão agora ou mais tarde?",
			"expiredBody": "Seu acesso ao teste OLX expirou em **{{date}}**.\n\nEntre em contato com seu professor ou administrador escolar para obter mais ajuda.",
			"startNowCta": "Começar agora",
			"startLaterCta": "Começar depois"
		},
		"unexpectedError": "Ocorreu um erro inesperado."
	},
	"redeemCode": {
		"titleRedeem": "Resgatar acesso",
		"titleGranted": "Acesso concedido",
		"formTitle": "Digite seu código de acesso",
		"accessCodeHint": "Se você tiver um código de acesso, digite-o aqui, incluindo os hífens.",
		"submit": "Enviar",
		"access": "Acessar aqui",
		"helpFindCode": "Precisa de ajuda para encontrar seu código de acesso?",
		"troubleRedeeming": "Está com dificuldade para resgatar? Pergunte ao Assistant!",
		"skipStep": "Pular esta etapa"
	},
	"autoRedeem": {
		"redeem": "Resgatar",
		"redeeming": "Resgatando...",
		"continue": "Continuar",
		"unredeemedPrompt_one": "Há **{{count}} assinatura** associada ao endereço de e-mail **{{email}}** que ainda não foi resgatada. Gostaria de adicioná-la à sua conta?",
		"unredeemedPrompt_other": "Há **{{count}} assinaturas** associadas ao endereço de e-mail **{{email}}** que ainda não foram resgatadas. Gostaria de adicioná-las à sua conta?",
		"successMessage_one": "Parabéns! O **produto** abaixo foi desbloqueado na sua conta. Depois de pressionar Continuar, o contexto do app será alterado para refletir a prova: **{{examName}}**. Você poderá alterar isso a qualquer momento nas configurações da conta se quiser estudar para outra prova ou comprar outra assinatura.",
		"successMessage_other": "Parabéns! Os **{{count}} produtos** abaixo foram desbloqueados na sua conta. Depois de pressionar Continuar, o contexto do app será alterado para refletir a prova: **{{examName}}**. Você poderá alterar isso a qualquer momento nas configurações da conta se quiser estudar para outra prova ou comprar outra assinatura."
	},
	"olxEligibility": {
		"goToPracticeTests": "Ir para os simulados"
	},
	"moreChallenges": {
		"challenges": "Desafios",
		"challengesCount": "{{value}} desafios"
	},
	"tts": {
		"tooltip": "Ouvir"
	},
	"commandBar": {
		"placeholder": "Pesquisar...",
		"input": {
			"placeholder": "Digite um comando ou pesquise"
		},
		"sections": {
			"quickActions": "Ações rápidas"
		},
		"actions": {
			"changeExam": "Alterar prova",
			"switchToDarkMode": "Mudar para o modo escuro",
			"switchToLightMode": "Mudar para o modo claro",
			"setExamDate": "Definir data da prova"
		}
	},
	"filterView": {
		"placeholder": "Pesquisar provas..."
	},
	"transcript": {
		"show": "Mostrar transcrição",
		"hide": "Ocultar transcrição"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "Logotipo do app",
			"testNameLabel": "Nome da prova",
			"sectionLabel": "Seção",
			"back": "Voltar",
			"pause": "Pausar",
			"menuLabel": "Mais opções"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Progresso da prova",
			"of": "de",
			"pauseSession": "Pausar sessão",
			"timerTooltip": {
				"item": "Tempo restante para esta questão",
				"section": "Tempo restante nesta seção",
				"test": "Tempo restante nesta prova"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "Próxima"
		},
		"progressBar": {
			"timeLeftLabel": "Tempo restante para esta questão",
			"timeLeftForUnit": "Tempo restante para esta unidade",
			"questionOf": "Questão {{current}} de {{total}}",
			"questionProgress": "<b>{{current}}</b> de {{total}}",
			"timesUp": "O tempo acabou",
			"statusTooltips": {
				"answered": "Respondida",
				"inProgress": "Em andamento",
				"skipped": "Ignorada",
				"notSeen": "Não visualizada"
			}
		},
		"timeRemainingDialog": {
			"title": "Você ainda tem tempo",
			"body": "Ainda há tempo restante nesta unidade. Gostaria de revisar suas respostas antes de enviar?",
			"reviewCta": "Revisar minhas respostas"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Origem",
				"answerTitle": "Sua resposta",
				"remainingBadge": "Restantes: {{count}}",
				"placedBadge": "Posicionados: {{count}}",
				"pointsBadge": "{{earned}}/{{max}} pontos",
				"emptyHint": "Arraste os parágrafos do painel esquerdo para cá"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Informações de suporte",
			"emailLabel": "E-mail",
			"subjectLabel": "Assunto",
			"messageBodyLabel": "Corpo da mensagem",
			"appDetailsLabel": "Detalhes do app",
			"appNameLabel": "Nome",
			"versionLabel": "Versão",
			"platformLabel": "Plataforma"
		},
		"chat": {
			"assistantTitle": "Assistente de suporte {{tenantName}}",
			"fallbackTitle": "Chat",
			"betaWarning": "Este assistente de IA está em **Beta** — as respostas podem, ocasionalmente, ser imprecisas ou incompletas.",
			"greeting": "Olá 👋 Está com dificuldade para acessar um produto? Estou aqui para ajudar! Primeiro, vamos identificar o problema. Qual das opções a seguir melhor descreve sua situação?\n\n1. Tenho um código de acesso, mas ele não parece estar funcionando.\n2. Fiz uma compra, mas não consigo encontrar meu código de acesso.\n3. Eu deveria ter recebido acesso pela minha escola, mas não consigo encontrar meu código de acesso.\n4. Eu tinha acesso a um produto anteriormente, mas agora não consigo mais acessá-lo.\n\nDigite o número correspondente ao seu problema.",
			"input": {
				"label": "Digite uma mensagem...",
				"sendLabel": "Enviar"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Resgatado com sucesso",
			"previouslyRedeemedTitle": "🚀 Resgatado anteriormente",
			"subtitle": "Acesse seu conteúdo aqui",
			"expires": "Expira em: {{date}}",
			"openCta": "Abrir"
		},
		"purchases": {
			"title": "🎉 Códigos de acesso encontrados",
			"subtitle": "Resgate para obter acesso ao seu conteúdo",
			"accessCodesLabel_one": "Código de acesso",
			"accessCodesLabel_other": "Códigos de acesso",
			"moreCodes_one": "(+ {{count}} a mais)",
			"moreCodes_other": "(+ {{count}} a mais)",
			"featuresLabel": "Recursos",
			"redeemCta": "Resgatar"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "Nova versão disponível, clique em atualizar para obtê-la.",
			"refreshCta": "Atualizar",
			"refreshA11yLabel": "Atualizar para obter a nova versão",
			"dismissTooltip": "Dispensar",
			"dismissA11yLabel": "Dispensar a notificação de atualização"
		}
	},
	"cme": {
		"type": "Tipo de CME",
		"chooseExportMethod": "Escolher método de exportação",
		"selectDateRange": "Selecionar intervalo de datas",
		"from": "De",
		"to": "Até",
		"sendPdfTo": "Enviar PDF para {{email}}",
		"downloadCertificate": "Baixar Certificado em PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "Crédito CME Obtido",
		"confirmYourName": "Confirme seu nome",
		"certificateNameNotice": "Este nome será impresso no seu Certificado CME.",
		"firstName": "Primeiro nome",
		"lastName": "Sobrenome",
		"firstNamePlaceholder": "Digite seu primeiro nome",
		"lastNamePlaceholder": "Digite seu sobrenome",
		"confirm": "Confirmar",
		"creditsEarnedTitle": "CME Obtido",
		"creditRatioCaption": "12 Desafios = 1 Crédito CME",
		"earned": "Obtido",
		"available": "Disponível",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "Exportar Certificado CME",
		"exportDisabledCaption": "Você precisa obter pelo menos 1 crédito CME para exportar seu certificado",
		"viewDisclaimer": "Ver isenção de responsabilidade de CME"
	}
}
